/** Entitlements' part of "Download my data": the caller's files here. */
export const myDataApi = '/entitlements/v1/me/data'
